import React from 'react';
import './v2_Button.css';

function getButtonClassName({ variant, className }) {
  const base = 'v2-btn';
  const v = variant ? `v2-btn--${variant}` : 'v2-btn--secondary';
  return [base, v, className].filter(Boolean).join(' ');
}

/**
 * Small, token-based button for UI v2.
 *
 * Variants:
 * - primary: important CTA
 * - secondary: default
 * - subtle: low emphasis
 * - danger: destructive actions
 * - success: positive/approve actions
 * - selected: selection state (uses --background-selected-default)
 */
function V2Button({ variant = 'secondary', className = '', children, ...props }) {
  return (
    <button type="button" className={getButtonClassName({ variant, className })} {...props}>
      {children}
    </button>
  );
}

export default V2Button;
